import React, { Component } from 'react'
import { homePageConstants } from './homeConstants';
import Video from 'src/Assets/Images/video.png';
import './styles.scss';
import PrimaryButtonGE from 'src/Components/PrimaryButtonGE/PrimaryButtonGE';
import { footerConstants } from 'src/Components/Footer/footerConstants';

export default class Login extends Component {
  INTERSECT_RATIO = 0.2;
  selectorsToAnimate = [
    ".first-heading__home",
    ".heading-paragraph",
    ".video-to-play",
    ".green-line-separator",
    ".below-line-text",
    ".heading__below-video",
    ".intro-para",
    ".question-text",
    ".learn-more-btn",
  ];

  componentDidMount() {
    let a = localStorage.getItem('isLoggedOut');
    if (a == 'true' || a === null) {
      localStorage.setItem('isLoggedOut', false);
      window.location.reload();
    }
    this.makeObserver();
  }

  handleLearnMoreClick = () => {
    let { link } = footerConstants.linkList[0];
    window.open(link);
  };

  getHeading = () => {
    const { heading } = homePageConstants;
    return (
      <React.Fragment>
        {heading.desktopHeading.firstHeadingLine1}
        <br />
        <span className="gradient-text">
          {heading.gradientText}
        </span>
      </React.Fragment>
    )
  }

  handleIntersect = allElements => {
    allElements.forEach(el => {
      if (el.intersectionRatio >= this.INTERSECT_RATIO) {
        el.target.classList.add("animate-in-view");
      }
    })
  }

  makeObserver = () => {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: this.INTERSECT_RATIO
    }
    const observer = new IntersectionObserver(this.handleIntersect, options);

    this.selectorsToAnimate.forEach(el => {
      let target = document.querySelector(el);
      observer.observe(target);
    })
  };

  render() {
    const { heading, belowVideoData } = homePageConstants;
    return (
      <div className="home-component-wrapper">
        <div className="center-data-container">
          <h1 className="first-heading__home">
            {this.getHeading()}
          </h1>
          <p className="heading-paragraph">
            {heading.desktopHeading.paragraph}
          </p>
          <img src={Video} className="video-to-play" alt="vid" />
          <div className="data-below-image-wrapper">
            <div className="data-below-image-container__inner">
              <hr className="green-line-separator" />
              <p className="below-line-text">{belowVideoData.belowLineText}</p>
              <p className="heading__below-video">
                {belowVideoData.headingFirstPart}
                <span className="mid-part-heading">
                  {belowVideoData.headingMidPart}
                </span>
                {belowVideoData.headingLastPart}
                <span className="last-heading">
                {belowVideoData.headingLastWord}
                </span>
                
              </p>
              <p className="intro-para">
                {belowVideoData.introPara}
              </p>
              <h6 className="question-text">
                {belowVideoData.questionText}
              </h6>
              <div className="button-wrapper">
                <PrimaryButtonGE
                  filled={false}
                  text={belowVideoData.learnMoreBtnText}
                  className="learn-more-btn"
                  onClick={this.handleLearnMoreClick}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
